import { watchActivateProspect } from './activateProspect';
import { watchChangeLifecycleStep } from './changeLifecycleStep';
import { watchCreateProspect } from './createProspect';
import { watchDeactivateProspect } from './deactivateProspect';
import { watchFetchProspect } from './fetchProspect';
import { watchFetchProspects } from './fetchProspects';
import { watchFreezeProspect } from './freezeProspect';
import { watchUpdateProspect } from './updateProspect';

export const prospectSagas = [
  watchActivateProspect(),
  watchChangeLifecycleStep(),
  watchCreateProspect(),
  watchDeactivateProspect(),
  watchFetchProspect(),
  watchFetchProspects(),
  watchFreezeProspect(),
  watchUpdateProspect()
];
